import { isNull } from 'lodash-es'
import Link from 'next/link'

import { formatDateWithDayOfWeek } from '@/shared/lib'
import { Button } from '@/shared/ui'

import { useGuestRefundCard } from '../../api/get-guest-refund-card'

type Props = {
  contractId: number
}

export const RefundCard = ({ contractId }: Props) => {
  const { refundCard } = useGuestRefundCard({
    contractId,
  })

  const isRefunded = refundCard?.isRefunded && !isNull(refundCard?.refundedAt)

  return (
    <div className="grow px-6">
      <h3 className="typo-body1 mb-3 font-semibold text-black">신용카드</h3>

      <div className="mb-4 space-y-2">
        <p className="typo-label1 font-medium text-gray-900">
          {refundCard?.cardName} {refundCard?.cardNo}
        </p>

        {isRefunded && (
          <p className="typo-body1 font-bold text-purple-500">
            {formatDateWithDayOfWeek({
              date: refundCard.refundedAt!,
            })}{' '}
            환불 완료
          </p>
        )}

        <p className="typo-label2 font-normal text-gray-500">
          환불 완료 후, 3~7일 이내 카드 부분 취소로 환불됩니다.
          <br />
          정확한 환불일은 카드사에 문의주시기 바랍니다.
        </p>
      </div>

      {isRefunded && (
        <Button variant="outline" size="medium" shape="pill" fullWidth asChild>
          <Link
            href={refundCard?.cardReceiptUrl ?? ''}
            target="_blank"
            rel="noopener noreferrer"
          >
            카드 전표
          </Link>
        </Button>
      )}
    </div>
  )
}
